/** @returns {string} */
export function renderAuthStyle() {
  return `
  .hauth-root {
    display: flex;
    justify-content: center;
    width: 100%;
    font-family: Arial, sans-serif;
    position: relative;
    z-index: 0;
  }

  .hauth-popup-dialog {
    border: 0;
    margin: auto;
    padding: 16px;
    max-width: none;
    width: min(552px, 100%);
    background: transparent;
    overflow: visible;
  }

  .hauth-popup-dialog[data-busy="true"] {
    filter: grayscale(1);
  }

  .hauth-popup-dialog::backdrop {
    pointer-events: auto; 
    background: rgba(65, 115, 165, 0.5);
    backdrop-filter: blur(5px);
  }

  .hauth-popup-window {
    width: min(520px, 100%);
    max-height: calc(100vh - 32px);
    border-radius: 14px;
    box-shadow: 0 3px 3px -2px #0003, 0 3px 4px #00000024, 0 1px 8px #0000001f;
    background-color: rgba(255, 255, 255, 0.93);
    padding: 14px 10px 10px;
    position: relative;
  }

  .hauth-popup-window::before {
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: 14px;
    z-index: -5;
  }

  .hauth-popup-window::after {
    position: absolute;
    width: 100vw;
    height: 100vh;
    max-height: 120%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: -1;
    content: "";
    background-image: var(--auth-backdrop-image);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
  }

  .hauth-popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px 8px;
  }

  .hauth-popup-close {
    border: 0;
    background: transparent;
    color: #2f4757;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
    border-radius: 999px;
    width: 32px;
    height: 32px;
  }

  .hauth-popup-close:hover {
    background: #eef4f7;
  }

  :host([mode="embedded"]) .hauth-popup-dialog {
    width: 100%;
    max-width: none;
    margin: 0;
    padding: 0;
    position: relative;
  }

  :host([mode="embedded"]) .hauth-popup-window {
    width: 100%;
    max-width: none;
    padding: 0;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  .logo-row {
    display: flex;
    justify-content: center;
  }

  .col-md {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    box-sizing: border-box;
  }

  .hauth-fieldset {
    border: 0;
    margin: 0;
    padding: 0;
  }

  .hauth-fieldset[disabled] {
    pointer-events: none;  
  }

  .logo {
    width: 120px;
    height: 76px;
    display: block;
    margin: 0 auto;
  }

  .form-control {
    width: 100%;
    height: 38px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 0 12px;
    font-size: 14px;
    line-height: 1.5;
    color: #212529;
    background: transparent;
    box-sizing: border-box;
    outline: 0;
  }

  .form-control:focus {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  }

  .form-control[aria-invalid="true"] {
    border-color: #c1121f;
  }

  .text-danger {
    margin-top: 6px;
    min-height: 1rem;
    color: #c1121f;
    font-size: 12px;
    line-height: 1.3;
  }

  .login-link {
    color: #009fdf;
    font-size: 14px;
    line-height: 20px;
    text-decoration: none;
  }

  .login-link:hover {
    text-decoration: underline;
  }

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 12px;
    padding: 6px 16px;
    font-size: 14px;
    line-height: 1.5;
    cursor: pointer;
    outline: none;
    background-image: none;
  }

  .btn-primary {
    background-color: #009fdf;
    border-color: #009fdf;
    color: #ffffff;
    font-weight: 400;
  }

  .btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  #loginButton {
    padding: 6px 16px;
    font-size: 16px;
  }

  .mobile-invisible {
    font-size: 14px;
    color: #333;
    line-height: 20px;
  }

  .login-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding-top: 20px;
    margin-top: 17px;
  }

  .footer-text {
    margin: 0;
  }

  .copyright {
    color: #999;
    font-size: 12px;
    text-decoration: none;
  }

  .hygiena-logo {
    width: 120px;
    height: 32px;
    object-fit: contain;
  }

  @media only screen and (max-width: 700px) {
    .mobile-invisible {
      display: none !important;
    }
  }

  @media (max-width: 640px) {
    .login-container {
      padding: 16px;
    }

    .login-footer {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;
}
